export const NUMBER_FORMATING_KEY = "numberFormatType";